import { useCallback } from "react";
import { LicenseManagerApi, useAPIAction } from "melco-shared-logic";
import { getUTCObjectFromLocalDate } from "../../helper/dateHelper";

export interface LicenseManagerChangeLevelInterface {
  email_address?: string;
  serial_number?: string;
  step: number;
  version_id?: string;
  subscription_code?: string;
  product_code?: string;
  referral_code?: string;
  melco_customer_id?: string | null;
  language?: string | null;
  subscription_start_date?: Date | null;
}

export const useLicenseManagerChangeLevel = () => {
  const [LicenseManagerChangeLevel] = useAPIAction(
    LicenseManagerApi,
    async (
      api,
      LicenseManagerChangeLevelDetails: LicenseManagerChangeLevelInterface
    ) => {
      let localDate = LicenseManagerChangeLevelDetails.subscription_start_date;
      let data = await api.licenseManagerLicensesManagerUpdate({
        controlcenterMelcoControlCenterModelsChangeLicenseLevel: {
          product_code: LicenseManagerChangeLevelDetails.product_code,
          subscription_code: LicenseManagerChangeLevelDetails.subscription_code,
          serial_number: LicenseManagerChangeLevelDetails.serial_number,
          step: LicenseManagerChangeLevelDetails.step,
          referral_code: LicenseManagerChangeLevelDetails.referral_code,
          version_id: LicenseManagerChangeLevelDetails.version_id,
          melco_customer_id: LicenseManagerChangeLevelDetails.melco_customer_id,
          language: LicenseManagerChangeLevelDetails.language,
          subscription_start_date: localDate
            ? getUTCObjectFromLocalDate(localDate).utcStartOfDay
            : undefined,
        },
      });

      return {
        successMessages:
          LicenseManagerChangeLevelDetails.step == 3
            ? [{ message: "default" }]
            : [],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "licensemanager.changelevel" }
  );

  return useCallback(
    async (
      LicenseManagerChangeLevelDetails: LicenseManagerChangeLevelInterface
    ) => {
      return await LicenseManagerChangeLevel(LicenseManagerChangeLevelDetails);
    },
    [LicenseManagerChangeLevel]
  );
};
